(function ($) {
    'use strict';

    var loginUsername, loginPassword, rememberme;

    loginUsername = $('.login-username');
    loginPassword = $('.login-password');
    rememberme = $('#rememberme');

    loginUsername.addClass('material-group');
    loginPassword.addClass('material-group');

    rememberme.on('change', function () {
       var that = $(this);

       if (that.is(':checked')){
           that.closest('label').addClass('checked');
       }else{
           that.closest('label').removeClass('checked');
       }
    });

})(jQuery);